<div (click)="open()"
>
  {{ title }}
</div>
